import { React, useState, useEffect, useRef } from "react";
import {
  RightLayoutContainer,
  DetailFields,
  GroupTitle,
  PageTitleComp,
} from "../../styledElements";
import { Button, Row, Col, Form, Input, PageHeader, Radio } from "antd";
import Iconmoon from "../../../Components/IconsFiles/icon";
import { HaberForm } from "../../styledElements";
import { useNavigate, useLocation } from "react-router-dom";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import moment from "moment";
import {
  currency_List,lengthUnit,weightUnit 
  } from "../../../Utils/Constant/MeasurementUnitList.jsx";
  
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);

const exportRewinderData = [
  { label: "CSV", value: "CSV" },
  { label: "PDF", value: "PDF" },
];

const headers = [
    { label: "REWINDER CODE", key: "rewinder_code" },
    { label: "REWINDER NAME", key: "rewinder_name" },
    { label: "MIN. GSM", key: "minimum_gsm" },
    { label: "MAX. GSM", key: "maximum_gsm" },
    { label: "MIN. DECKLE WIDTH", key: "minimum_width" },
    { label: "MAX. DECKLE WIDTH", key: "maximum_width" },
    { label: "LEFT EDGE TRIM", key: "left_edge_trim" },
    { label: "RIGHT EDGE TRIM", key: "right_edge_trim" },
    { label: "EFFECTIVE. DECKLE LENGTH", key: "effective_deckle_length" },
    { label: "MAX. ALLOWED TRIM LOSS (%)", key: "maximum_loss" },
    { label: "MAX.CUTTERS", key: "max_cutters" },
    { label: "STATUS", key: "status" },
    { label: "LOADING STANDS", key: "loading_stands" },
    { label: "SUPPORTED PLY", key: "ply" },
    { label: "REWINDER CAPACITY", key: "capacity" },
    { label: "REMARKS", key: "remarks" },
  ];

  const ExportRewinder = (props) => {
    const [exportRewinderDetail, setexportRewinderDetail] = useState(
      exportRewinderData[1].value
    );
    const location = useLocation();
    const [parentRecords, setParentRecords] = useState(location.state?.rewinderRecords);
    const [rewinderRecords, setRewinderRecords] = useState([]);
    const [fileName, setFileName] = useState(location.state?.fileName?  location.state?.fileName : "Rewinder_Records")
    const history = useNavigate();

    useEffect(() => {
      if(!location?.state?.onBack){
          fetchRewinderRecords();
      } else{
        setRewinderRecords(parentRecords);
      }
    }, [parentRecords]);

    useEffect(()=> {
      if(rewinderRecords?.length){
        if (!location?.state?.onBack) {
          if(exportRewinderData === "PDF"){
            history("../rewinder-records/export-rewinder/pdf", {
                  state: {
                      body: location?.state?.body,
                      rewinderRecords: rewinderRecords,
                      rootPage: location?.state?.rootPage,
                      fileNameForPDF: fileName,
                      exportRewinderDetail: exportRewinderDetail
                    },
            });
          }
          else
          {
            exportHandler();
          }
        }
    }
    },[rewinderRecords]);

    const fetchRewinderRecords = async () => {
      try {
          const formattedRecords = parentRecords?.map((rewinder) => {
          return {
              rewinder_code: rewinder.code,
              rewinder_name: rewinder.name,
              minimum_gsm: rewinder.minimum_gsm,
              maximum_gsm: rewinder.maximum_gsm,
              minimum_width: rewinder.minimum_width + " " + lengthUnit[rewinder.units.minimum_width].displayName,
              maximum_width: rewinder.maximum_width + " " + lengthUnit[rewinder.units.maximum_width].displayName,
              width_range: `${rewinder.minimum_width} - ${rewinder.maximum_width} ${lengthUnit[rewinder.units.maximum_width].displayName}`,
              left_edge_trim: rewinder.left_edge_trim + " " + lengthUnit[rewinder.units.left_edge_trim].displayName,
              right_edge_trim: rewinder.right_edge_trim + " " + lengthUnit[rewinder.units.right_edge_trim].displayName,
              effective_deckle_length: rewinder.effective_deckle_length + " " + lengthUnit[rewinder.units.effective_deckle_length].displayName,
              maximum_loss: rewinder.maximum_loss,
              status: rewinder.status === "active" ? "Active" : "Disabled",
              max_cutters: rewinder.maximum_cutters,
              remarks: rewinder.remarks,
              gsm_range: `${rewinder.minimum_gsm} - ${rewinder.maximum_gsm}`,
              units : rewinder.units,
              capacity: rewinder.capacity + " " + capitalize(weightUnit[rewinder.units.capacity].displayName) + ' / day',
              loading_stands : rewinder.loading_stands,
              ply : rewinder.ply ? rewinder.ply.join(", ") : '-',
          };
        });
        setRewinderRecords(formattedRecords);
        setexportRewinderDetail(location?.state?.exportRewinderDetail);
      } catch (err) {
          console.log("Error in fetching rewinder records", err);
        }
    };

    const exportStatusChange = (e) => {
      setexportRewinderDetail(e.target.value);
    };

    const exportHandler = async() => {
      if(rewinderRecords?.length){
        if(exportRewinderDetail === "CSV"){
          try{
            const workbook = new ExcelJS.Workbook();
            const worksheet = workbook.addWorksheet('Rewinder Records');
  
            worksheet.columns = headers.map((header)=>({
              header: header.label,
              key: header.key,
            }))
  
            const headRow = worksheet.getRow(1);
  
            headRow.eachCell((cell)=>{
              cell.fill = {
                type: "pattern",
                pattern: "solid",
                fgColor: {
                  argb: "f3f4f6"
                }
              }
              cell.font = {
                bold: true,
              }
            })
  
            rewinderRecords?.forEach((record)=>{
              const row = worksheet.addRow(record);
            })
  
            worksheet.columns.forEach((column)=>{
              let maxLength = 10;
              column.eachCell((cell)=>{
                let value = cell?.value?.toString() || "";
                maxLength = Math.max(maxLength,value?.length);
              })
              column.width = maxLength>50?50:maxLength+2;
            })
  
            const buffer = await workbook.xlsx.writeBuffer();
            saveAs(new Blob([buffer]),`${fileName}.xlsx`)
          }
          catch(e)
          {
            console.log(e);
          }
        } else {
          history("../rewinder-records/export-rewinder/pdf", {
                  state: {
                      body: location?.state?.body,
                      rewinderRecords: rewinderRecords,
                      rootPage: location?.state?.rootPage,
                      fileNameForPDF: fileName,
                      exportRewinderDetail: exportRewinderDetail
                    },
            });
        }
      } else{
        history("../rewinder-records/preparing-export-rewinder", {
          state: {
            body: location?.state?.body,
            rootPage: location?.state?.rootPage,
            fileName: fileName,
            headers: headers,
            exportRewinderDetail: exportRewinderDetail
          },
        });
      }
    };

    return (
      <RightLayoutContainer>
         <PageTitleComp className="marginRightAdg">
            <PageHeader
              ghost={false}
              onBack={() => history("../rewinder-records")}
              title="Export rewinder records"
              extra={[
                <Button
                  key="1"
                  className="themeBtn noBg"
                  onClick={() => history("../rewinder-records")}
                >
                  <Iconmoon icon="wrong" size={14} color="#EA655B" />
                  Cancel
                </Button>,
              ]}
            ></PageHeader>
          </PageTitleComp>
          <DetailFields>
            <HaberForm>
              <div className="groupDetailWrap">
                <Form name="basic" autoComplete="off" className="haberLogin">
                <Row gutter={[16, 16]} className="groupForm lastGroup">
                  <Col span={8}>
                    <GroupTitle>
                      <h2>Select Options</h2>
                      <p>
                        Here you can select options to customize data that will be
                        downloaded
                      </p>
                    </GroupTitle>
                  </Col>
                  <Col span={16}>
                    <Row className="centerAlign">
                      <Col span={12}>
                        <div className="boxFieldTitle">
                          <label>Data Format</label>
                          <p>Select a format to download data</p>
                        </div>
                      </Col>
                      <Col span={12}>
                        <div
                          className="boxFormType switchRadio"
                          style={{ justifyContent: "flex-end", display: "flex" }}
                        >
                          <Radio.Group
                            options={exportRewinderData}
                            onChange={exportStatusChange}
                            value={exportRewinderDetail? exportRewinderDetail : "PDF"}
                            optionType="button"
                            buttonStyle="solid"
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <div className="buttonRight" style={{ marginTop: "20px" }}>
                  <Form.Item>
                    {!exportRewinderDetail || exportRewinderDetail === "PDF" ? (
                      <Button
                        onClick={() => exportHandler()}
                        className="themeBtn"
                      >
                        Preview &#38; Download Records
                      </Button>
                    ) : (
                      <Button className="themeBtn csv"
                            onClick={() => exportHandler()}>
                              Download Rewinder Records
                      </Button>
                    )}
                  </Form.Item>
                </div>
                </Form>
              </div>
            </HaberForm>
          </DetailFields>
      </RightLayoutContainer>
    );
  };
  export default ExportRewinder;